<h2
  class="logo"
  routerLink="/"
  (click)="sharedService.logEvent('logo_clicked')"
>
  <img height="24" width="24" src="/assets/favicon.png" />gleemo
</h2>

<!-- nav -->
<div class="nav">
  <h2
    *ngFor="let tab of tabs"
    [routerLink]="tab.link"
    [ngClass]="{
      active: router.url === tab.link
    }"
    (click)="sharedService.logEvent('sign_out_clicked', { tab: tab.label })"
  >
    {{ tab.label }}
  </h2>
</div>

<ng-container *ngIf="userService.user; else auth">
  <!-- user menu -->
  <app-user-menu
    *ngIf="userMenuVisible"
    (close)="userMenuVisible = false"
  ></app-user-menu>
  <!-- avatar -->
  <kor-avatar
    [image]="userService.user.image"
    (click)="userMenuVisible = true; sharedService.logEvent('avatar_clicked')"
  ></kor-avatar>
</ng-container>

<ng-template #auth>
  <!-- auth modal -->
  <app-auth-modal
    *ngIf="userService.authModalVisible"
    (close)="userService.authModalVisible = false"
  ></app-auth-modal>
  <!-- sign in button -->
  <kor-button
    label="sign in"
    (click)="
      userService.authModalVisible = true;
      sharedService.logEvent('sign_in_launch')
    "
  ></kor-button>
</ng-template>
